import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Grid } from '@material-ui/core';
import {
  riskExistComorbidity,
  noRiskComorbidity,
} from 'on_web/assets/imageList';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

/**
 * Component displaying the overall risk for the group.
 */
export default function RiskGroupAssessmentCard(props) {
  const { t } = useTranslation();

  const useStyles = makeStyles(theme => ({
    text: {
      fontSize: '18px',
      fontFamily: 'Museo',
      fontWeight: 'bold',
    },
  }));

  const classes = useStyles();
  return (
    <Box
      style={{
        paddingLeft: '20px',
        paddingRight: '20px',
        marginTop: '14px',
        paddingBottom: '22px',
      }}
    >
      <Grid
        container
        direction="row"
        justify="flex-start"
        alignItems="flex-start"
      >
        <Grid item xs={8}>
          <Box className={classes.text}>
            {props.numberOfRisks === 0
              ? t(
                  'reporting.common.comorbiditiesCategories.conditionsNotHaving',
                  {
                    groupName: props.groupName,
                    pluralSuffix: props.numberOfRisks === 1 ? '' : 's',
                  }
                )
              : t('reporting.common.comorbiditiesCategories.conditionsHaving', {
                  conditionAmount: props.numberOfRisks,
                  groupName: props.groupName,
                  pluralSuffix: props.numberOfRisks === 1 ? '' : 's',
                })}
          </Box>
        </Grid>

        <Grid item xs={4}>
          <Box display="flex" justifyContent="flex-end">
            <img
              alt="risks"
              src={
                props.numberOfRisks === 0
                  ? noRiskComorbidity
                  : riskExistComorbidity
              }
              width={107}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

RiskGroupAssessmentCard.propTypes = {
  /**
   * Number of risky comorbidities in the group. Determines how group's risk is displayed.
   */
  numberOfRisks: PropTypes.number.isRequired,

  /**
   * Name of the group.
   */
  groupName: PropTypes.string.isRequired,
};
